import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';


function ThinCircleIcon(props: SvgIconProps) {
    return (
      <SvgIcon {...props}>
        <path d="M24,48A24,24,0,1,1,48,24,24,24,0,0,1,24,48ZM24,1A23,23,0,1,0,47,24,23,23,0,0,0,24,1Z"/>
    </SvgIcon>
    );
  }


export default ThinCircleIcon;